import { FlyerStatusTask, FlyerTask } from './types/flyer';
import { Task, TaskProvider } from "../../types";
import { getCheckStatusFlyer, getTasks } from '../../../../Services/Requests';

export class FlyerAdapter {
  static async getFeed(): Promise<FlyerTask[]> {
    try {
      const res = await getCheckStatusFlyer();
      console.log("📦 Получены задания от Flyer:", res);

      const tasks = (Array.isArray(res.tasks) ? res.tasks : []) as FlyerTask[];
      const sortStatus = [
        'DONE',
        'NOT_STARTED',
        'IN_PROGRESS',
        'WAITING',
        'CLAIMED'
      ]

      return tasks
        .map((task: FlyerTask) => ({ // Явно указываем тип task
          ...task,
          provider: "FLYER" as const,
        }))
        .filter(t => t.task_type !== 'give boost')
        .sort((a, b) => {
          return sortStatus.indexOf(a.status) - sortStatus.indexOf(b.status)
        });
    } catch (error) {
      console.error("❌ Ошибка получения заданий от Flyer:", error);
      return [];
    }
  }

  static async getStatusTasks(): Promise<FlyerStatusTask[]> {
    try {
      const res = await getCheckStatusFlyer();
      const statusTasks = (Array.isArray(res.tasks) ? res.tasks : []) as FlyerStatusTask[];
      const sortStatus = [
        'DONE',
        'NOT_STARTED',
        'IN_PROGRESS',
        'WAITING',
        'CLAIMED'
      ]

      console.log("📋 Статусы заданий Flyer (внешний запрос):", statusTasks);
      return statusTasks.sort((a, b) => { return sortStatus.indexOf(a.status) - sortStatus.indexOf(b.status) });
    } catch (error) {
      console.error("❌ Ошибка получения статусов заданий Flyer (внешний запрос):", error);
      return [];
    }
  }

  static async adaptTasks(flyerTasks: FlyerTask[], statusTasks?: FlyerStatusTask[]): Promise<Task[]> {
    console.log("🔄 FlyerAdapter.adaptTasks - start", { flyerTasks });
    console.log("🔄 - - - - - - FlyerAdapter.adaptTasks - statusTasks:", this.getStatusTasks());

    try {
      const currentStatusTasks = statusTasks ?? await this.getStatusTasks();
      console.log("📋 Текущие статусы заданий Flyer:", currentStatusTasks);

      const adaptedTasks = flyerTasks.reduce<Task[]>((acc, task) => {
        const statusTask = currentStatusTasks.find(st => st.task_id === task.task_id);
        const status = statusTask?.status || 'NOT_STARTED';

        // если image_url = null, используем дефолтное изображение
        let image_url = task.image_url ? task.image_url : '';

        console.log("image_url --------- ", image_url);

        const buttonText = status === 'WAITING' ? 'Проверка' : '';

        acc.push({
          id: task.task_id,
          title: task.title,
          description: task.description,
          icon: image_url,
          type: 'sponsors',
          rewards: {
            tickets: 1,
          },
          status,
          buttonText,
          link: task.link,
          progress: {
            current: 0,
            total: 1,
          },
          provider: 'FLYER' as TaskProvider
        });

        return acc;
      }, []);

      return adaptedTasks
    } catch (error) {
      console.error("❌ Ошибка при адаптации заданий Flyer:", error);
      return []
    }
  }
}
